






















import Vue from 'vue';

import {
  booth,
  Booth,
  brand,
  Brand,
} from 'mostra';

interface DataType {
  loading: boolean;
  booths: Booth[];
  brands: Brand[];
  owner: string | null
}

export default Vue.extend({
  name: 'exhibitor-booth-top',
  data(): DataType {
    return {
      loading: true,
      booths: [],
      brands: [],
      owner: null,
    };
  },
  methods: {
    toCreatePage() {
      this.$router.push({
        name: 'exhibitor-booth-new',
        query: { page: 'settings' },
      });
    },
    async fetchData() {
      try {
        this.loading = true;
        this.$loading(true);
        this.owner = this.$auth.cid;
        this.booths = await booth.loadsByOwner(this.$auth.cid);
        this.brands = await brand.loadsByOwner(this.$auth.cid);
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        this.loading = false;
        this.$loading(false);
      }
    },
  },
  async beforeRouteUpdate(to, from, next) {
    next();
    await this.fetchData();
  },
  async mounted() {
    await this.fetchData();
  },
});
